module.exports = __webpack_public_path__ + "img/icon-tools.baa2f308.svg";